import { render, staticRenderFns } from "./modal-managetagsfilters.vue?vue&type=template&id=15ed338d&scoped=true&"
import script from "./modal-managetagsfilters.vue?vue&type=script&lang=js&"
export * from "./modal-managetagsfilters.vue?vue&type=script&lang=js&"
import style0 from "./modal-managetagsfilters.vue?vue&type=style&index=0&id=15ed338d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed338d",
  null
  
)

export default component.exports